import React from 'react';
import propTypes from 'prop-types';
import MainSectionCarriers from './MainSectionCarriers';
import CarrierAppointmentsByStateMap from './CarrierAppointmentsByStateMap';
import SelectedCarrierDetails from './SelectedCarrierDetails';
import ActionableAppointments from './ActionableAppointments';

export default function CarrierAppointmentsMainSection({
  showByStateMap,
  carrierPartnersMap,
  onMapStateClick,
  mapSelectedStateCode,
  carrierTypeOptions,
  selectedCarrierTypes,
  onCarrierTypesChange,
  groupedCarriers,
  onCarrierClick,
  activeCarrier,
  handleResetActiveCarrier,
  currentTab,
  actionNeededTabId,
  carriers,
  useSimpleCarrierCards = false
}) {
  if (activeCarrier.name) {
    return (
      <SelectedCarrierDetails
        handleResetActiveCarrier={handleResetActiveCarrier}
        activeCarrier={activeCarrier}
        onCarrierClick={onCarrierClick}
      />
    );
  }

  if (currentTab === actionNeededTabId) {
    return (
      <div data-tour='carrier-appt-action' className='flex min-h-0 min-w-0 w-full flex-1 flex-col'>
        <ActionableAppointments carriers={carriers} />
      </div>
    );
  }

  if (showByStateMap) {
    return (
      <div data-tour='carrier-appt-map' className='flex min-h-0 min-w-0 w-full flex-1 flex-col'>
        <CarrierAppointmentsByStateMap
          carrierPartnersMap={carrierPartnersMap}
          onStateClick={onMapStateClick}
          selectedStateCode={mapSelectedStateCode}
          carrierTypeOptions={carrierTypeOptions}
          selectedCarrierTypes={selectedCarrierTypes}
          onCarrierTypesChange={onCarrierTypesChange}
        />
      </div>
    );
  }

  return (
    <div data-tour='carrier-appt-grid' className='flex min-h-0 min-w-0 w-full flex-1 flex-col'>
      <MainSectionCarriers
        groupedCarriers={groupedCarriers}
        onCarrierClick={onCarrierClick}
        activeCarrierName={activeCarrier.name}
        useSimpleCarrierCards={useSimpleCarrierCards}
      />
    </div>
  );
}

CarrierAppointmentsMainSection.propTypes = {
  showByStateMap: propTypes.bool.isRequired,
  carrierPartnersMap: propTypes.object,
  onMapStateClick: propTypes.func,
  mapSelectedStateCode: propTypes.string,
  carrierTypeOptions: propTypes.array,
  selectedCarrierTypes: propTypes.arrayOf(propTypes.string),
  onCarrierTypesChange: propTypes.func,
  groupedCarriers: propTypes.array,
  onCarrierClick: propTypes.func.isRequired,
  activeCarrier: propTypes.object.isRequired,
  handleResetActiveCarrier: propTypes.func.isRequired,
  currentTab: propTypes.string.isRequired,
  actionNeededTabId: propTypes.string.isRequired,
  carriers: propTypes.array.isRequired,
  useSimpleCarrierCards: propTypes.bool
};
